import React, {useEffect, useState} from "react";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {IngredientUnits} from "../../enums/enums";
import {camelToTitle, capitalize} from "../../components/Utility";
import {createExpenseProduct} from "../../store/expense-product-slice";

const ExpenseProductAdd = () => {
    const params = useParams();
    const expenseType = params.expenseType;
    const dispatch = useDispatch();
    const navigator = useNavigate();

    const [productsToAdd, setProductsToAdd] = useState([{
        name: '',
        unit: 'kg',
    }]);

    //Product errors
    const [productErrors, setProductErrors] = useState([
        {name: '', unit: ''}
    ]);

    const userRole = useSelector((state) => state.auth.selectedRole);
    const {createStatus, error} = useSelector((state => state.expenseProduct))

    const {
        items,
    } = useSelector(state => state.menu.transactionType);

    const expenseTypeId = items.find(
        (item) => item.name.toLowerCase() === expenseType.toLowerCase()
    )?._id;

    const handleProductChange = (index, field, value) => {
        setProductsToAdd(prev => {
            const updated = [...prev];
            updated[index] = {...updated[index], [field]: value};
            return updated;
        });
    };

    const handleAddRow = () => {
        setProductsToAdd(prev => [...prev, {name: '', unit: 'kg'}]);
        setProductErrors(prev => [...prev, {name: '', unit: ''}]);
    };

    const handleRemoveRow = (index) => {
        setProductsToAdd(prev => prev.filter((_, i) => i !== index));
        setProductErrors(prev => prev.filter((_, i) => i !== index));
    };

    //Validate Product row
    const validateProductRow = (product, index) => {
        const errors = {};

        if (!product.name) errors.name = 'Name is required';
        if (!product.unit) errors.unit = 'Unit is required';

        setProductErrors(prev => {
            const newErrors = [...prev];
            newErrors[index] = errors;
            return newErrors;
        });

        return Object.keys(errors).length === 0;
    };

    const validateAllProducts = () => {
        return productsToAdd.map((product, index) =>
            validateProductRow(product, index)
        ).every(valid => valid);
    };

    const handleProductBlur = (index, field) => {
        const product = productsToAdd[index];
        validateProductRow(product, index);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const areProductsValid = validateAllProducts();
        if (!areProductsValid) return;

        const data = {
            ttid: expenseTypeId,
            products: productsToAdd?.some(item => Object.values(item).some(Boolean)) ? productsToAdd : []
        }
        dispatch(createExpenseProduct({...userRole, data}));
    };

    useEffect(() => {
        if (createStatus === "success") {
            navigator('../');
        }
    }, [createStatus, navigator]);


    return (
        <>
            <SubHeader title={`Add ${capitalize(params.expenseType)} Product`}>
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            {error && <p className="align-self-center mb-2 text-danger fs-md fw-medium">{error}</p>}
            <form onSubmit={handleSubmit}>
                <div className="row gap-6">
                    {/*Add Products*/}
                    <div className="col-lg-7">
                        <table className="table table-borderless table-sm fs-md mobile-responsive table-va-top">
                            <thead>
                            <tr>
                                <th>Product</th>
                                <th>Unit type</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {productsToAdd.map((item, index) => (
                                <tr key={index}>
                                    <td className="align-top">
                                        {/* Product Name */}
                                        <input
                                            className="form-control"
                                            id="name"
                                            name="name"
                                            type="text"
                                            onBlur={() => handleProductBlur(index, "name")}
                                            value={item.name}
                                            onChange={(e) => handleProductChange(index, "name", e.target.value)}
                                        />
                                        {productErrors[index]?.name && (
                                            <div
                                                className="invalid-feedback d-block">{productErrors[index].name}</div>
                                        )}
                                    </td>

                                    <td className="align-top">
                                        {/* Unit Type Select */}
                                        <select
                                            className="form-select"
                                            name="unitType"
                                            value={item.unit}
                                            onBlur={() => handleProductBlur(index, "unit")}
                                            onChange={(e) =>
                                                handleProductChange(index, "unit", e.target.value)
                                            }
                                        >
                                            <option value="" disabled>
                                                Select unit type
                                            </option>
                                            {
                                                Object.keys(IngredientUnits).map((key) => {
                                                    const value = IngredientUnits[key];
                                                    return <option key={key} value={value}>{camelToTitle(key)}</option>
                                                })
                                            }
                                        </select>
                                        {productErrors[index]?.unit && (
                                            <div
                                                className="invalid-feedback d-block">{productErrors[index].unit}</div>
                                        )}
                                    </td>

                                    <td className="align-top">
                                        {/* Add/Remove Buttons */}
                                        <button className="btn btn-outline-success me-2" type="button"
                                                onClick={handleAddRow}>
                                            +
                                        </button>
                                        {productsToAdd.length > 1 && (
                                            <button
                                                className="btn btn-outline-danger"
                                                type="button"
                                                onClick={() => handleRemoveRow(index)}
                                            >
                                                −
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <button type="submit" className="btn btn-primary mt-3">
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}
export default ExpenseProductAdd;
